<script setup>
import { computed, ref, onMounted, watch } from "vue";
import LiveFixtureDoubleMarketOverviewOdd from '@/components/pre_sports/highlights/LiveFixtureDoubleMarketOverviewOdd.vue';
import LiveFixtureDoubleSecondMarketOverviewOdd from '@/components/pre_sports/highlights/LiveFixtureDoubleSecondMarketOverviewOdd.vue';
import { useMarketsStore } from '@/stores/markets'
import menuIcons from '@/assets/svgs/NotificationMenu.json'
import CustomSelect from './CustomSelect.vue'
import { useRouter } from "vue-router";

/* eslint-disable */
const menu_icons = ref(menuIcons);
const selectedLine = ref(null);
const router = useRouter();

const props = defineProps({
  overview_market: {
    type: Object,
    required: true,
  },
  fixture_overview_markets: {
    type: Object,
    required: false,
  },
  fixture: {
    type: Object,
    required: true,
  },
  type: {
    type: String,
    required: false,
    default: 'primary'
  },
    show_totals: {
    type: Boolean,
    required: false,
    default: false
  },
  odd_animation: {
    type: Boolean,
    required: false,
    default: true
  },
  add_margin: {
    type: Boolean,
    default: false
  }
});

const marketsStore = useMarketsStore();

onMounted(() => {
    handleTotalSelectedLine();
});

const isLine = computed(() => {
    if (props.overview_market?.market_type == 'totals_new' || props.overview_market?.market_type == 'handicap_new') return true;

    return false;
});

const getInitialClass = computed(() => {
    if (props.type == 'primary') return 'betting_info ' + bettingInfoClass.value;
    return 'match-score_info '  + bettingInfoClass.value
});

const getClassPrefix = computed(() => {
    if (props.type == 'primary') return 'betting-info' ;
    return 'match-score'
});

const getClassPrefixHeader = computed(() => {
    if (props.type == 'primary') return 'betting_info' ;
    return 'match-score_info'
});



const bettingInfoClass = computed(() => {
    if (isLine.value && props.overview_market.three_way) return 'betting-info-selector-3'
	if (isLine.value) return 'betting-info-selector'
    return '';
});


const goToFixture = () => {
    if (props.fixture.live) {
        router.push({ name: 'live-sports-eventview', params: { fixture_id: props.fixture.id } })
    } else {
        router.push({ name: 'pre-sports-fixturebook', params: { sport_id: props.fixture.sport_id, region_id: props.fixture.region_id, competition_id: props.fixture.competition_id, fixture_id: props.fixture.id } } )
    }
}

const handleTotalSelectedLine = () => {
    if (!isLine.value) return;

    let selected_overview_market = props.fixture_overview_markets[props.overview_market.slug];

    let line_prices = {};
    for (const line in selected_overview_market) {
        let sum = 0;
        for (const odd in selected_overview_market[line]) {
            sum += Number(selected_overview_market[line][odd].price);
        }

        line_prices[line] = sum / Object.keys(selected_overview_market[line]).length;
        line_prices[line] = line_prices[line] - 2;
    }

    // get min line price
    let min_price = Infinity;
    let min_line = null;
    for (const line in line_prices) {
        if (line_prices[line] < min_price) {
            min_price = line_prices[line];
            min_line = line;
        }
    }

    selectedLine.value = min_line;
};

const overviewMarketOddNames = computed(() => {
    if (props.overview_market.three_way) return props.overview_market.odd_names;


    delete props.overview_market.odd_names[1];

   return Object.values(props.overview_market.odd_names)
});

const overviewMarketOdds = computed(() => {
	if (!props.fixture_overview_markets.hasOwnProperty(props.overview_market.slug)) return [];
	return props.fixture_overview_markets[props.overview_market.slug];
});

const sortedLines = computed(() => {

    if (props.overview_market.market_type == 'handicap_new') {
        let keys = [];
        for (const key in overviewMarketOdds.value) {
            if (overviewMarketOdds.value[key]) keys.push(key);
        }

        return keys.sort();
    }


    let xouinies = Object.keys(overviewMarketOdds.value)
    .map(Number)
    .sort((a, b) => a - b)
    return xouinies;
    // .map(n => n.toFixed(1))
});

const requiresSelector = computed(() => {
    const selector_markets = ['totals_new', 'handicap_new'];
    if (selector_markets.includes(props.overview_market?.market_type)) return true;

    return false;
});
const selectedViewOdds = computed(() => {
    let odds;
    if (!isLine.value) {
        odds = overviewMarketOdds.value;
    } else {
        odds = overviewMarketOdds.value[selectedLine.value];

    }

    if (odds == undefined) odds = {};
    for (let index = 0; index < overviewMarketOddNames.value.length; index++) {
       if (odds[index] == null) odds[index] = null;
    }

    return odds;
});

watch(() => props.overview_market, (newVal, oldVal) => {
    handleTotalSelectedLine();
},{ deep: true })


</script>
<template>
    <div :class="getInitialClass" :style="add_margin ? { 'margin-top': '20px' } : {}">
        <template v-if="requiresSelector">
            <CustomSelect  v-if="sortedLines.length > 0" v-model="selectedLine" :options="sortedLines" />
           <div v-else :class="getClassPrefix + '-inner'">
                <div class="desktop-bet">
                    <div :class="getClassPrefix + '-main'">
                        <h6 v-html="menu_icons.lock"></h6>
                    </div>
                </div>
                <div v-if="props.type == 'primary' " class="mobile-bet totals_new" style="justify-content: center; align-items: center;">
                    <div :class="getClassPrefix + '-right'">
                        <h6 v-html="menu_icons.lock"></h6>
                    </div>
                </div>
            </div>
        </template>

        <template v-for="odd, index in selectedViewOdds" :key="index">

            <LiveFixtureDoubleMarketOverviewOdd v-if="props.type=='primary'"
				:overview_market_header_name="overviewMarketOddNames[index]"
				:overview_odd="odd"
				:needs_indicator="marketsStore.overviewMarketNeedsIndicator(overview_market)"
				:fixture_id="props.fixture.id"
                :odd_animation="props.odd_animation"
			/>

            <LiveFixtureDoubleSecondMarketOverviewOdd v-else
				:overview_market_header_name="overviewMarketOddNames[index]"
				:overview_odd="odd"
				:needs_indicator="marketsStore.overviewMarketNeedsIndicator(overview_market)"
				:fixture_id="props.fixture.id"
                :odd_animation="props.odd_animation"
			/>

        </template>
        <div v-if="show_totals" class="total-bet" @click="goToFixture">
            <div class="total-bet-main">
                <h6>{{ fixture.odds_count }} {{$t('account.affiliate.bets')}}</h6>
            </div>
        </div>
    </div>
</template>
<style scoped>
.betting-info-main {
    text-align: center;
}
.betting_info .betting-info-inner {
    color: var(--dark-gray)  !important;
}

.match-score_info .match-score-inner {
    color: var(--dark-gray)  !important;
}

.mobile-bet.totals_new {
    display: flex;
    justify-content: center;
    align-content: center;
}

.match-score_info.betting-info-selector {
    display: grid  !important;;
    grid-template-columns: 16% auto auto 18% !important;
}

.betting_info.betting-info-selector {
    display: grid  !important;;
    grid-template-columns: 20% auto auto !important;
}

.betting_info.betting-info-selector-3 {
    display: grid  !important;;
    grid-template-columns: 16% auto auto auto !important;
}


@media screen and (min-width: 320px) and (max-width: 767px) {
   .betting_info .betting-info-inner {
        grid-template-columns: 1fr;
        padding: 0px 0px;
        gap: 5px;
        justify-content: center;
        align-items: center;
    }
}
@media (pointer: fine) {
    .betting-info-inner.overview-lines:hover {
        background: var(--light-gray) !important;
        color: var(--white) !important;
        cursor: pointer;
    }

     .match-score-inner.overview-lines:hover {
        background: var(--light-gray) !important;
        color: var(--white) !important;
        cursor: pointer;
    }
}

.total-bet {
    display: flex !important;
    align-self: stretch !important;
    height: 100% !important;
}

.total-bet .total-bet-main {
    min-height: 44px;
    width: 100% !important;
    height: 100% !important;
    box-sizing: border-box !important;
    display: flex !important;
    flex-direction: column !important;
    justify-content: center !important;
    align-items: center !important;
    padding: 5px 5px !important;
}
</style>